import { EXISTED_STATSIG_AB_TESTS } from '../ab-tests/ab-tests';

export const QUERY_FEATURE_FLAG = {
    BETA: 'beta',
    NOT_ACTIVE_CAMPAIGN_PAGE: 'notActiveCampaignPage',
    FORCE_REGISTRATION_PAGE: 'forceRegistrationPage',
    DOUBLE_OPT_IN_MODAL: 'doubleOptInModal',
    REAL_AGB_TEST: 'realAGBTest',
    WORLD_TEST: 'world-test',
    SALE_DAYS: 'saleDays',
    LAST_SALE_DAY: 'lastSaleDay',
    PREPARE_DAYS: 'prepareDays',
    DEMOCRACY: 'democracy',
    PERSONALIZATION_ONBOARDING_MODAL: 'personalizationOnboardingModal',
    SEARCH_DROPDOWN: 'searchDropdown',
    SHOW_ADD_SCHOOL_WISHLIST_BUTTON: 'showAddSchoolWishlistButton',
    SHOW_PROMOTE_APP_MODAL: 'showPromoteAppModal',
    SHOW_QUALITY_LABEL: 'showQualityLabel',
    TEST_AUGUST_PRICE_RELEASE: 'testAugustPriceRelease',
    SHOW_UPSELLING_THANK_YOU: 'showUpsellingThankYou',
    SHOW_NEW_WORLDS_MODAL: 'showNewWorldsModal',
    CREATE_INTERACTIVE: 'createInteractive',
    AUTO_CREATE_INTERACTIVE: 'autoCreateInteractive',
    AUTO_START_ADAPT: 'autoStartAdapt',
    TEST_DELAYED_MSG: 'testDelayedMsg',
    TEST_MY_UPLOADS_SURVEY_BANNER: 'testMyUploadsSurveyBanner',
    TEAM_DAYS_BANNER: 'teamDaysBanner',
    PREVIEWS_QUALITY: 'previewsQuality',
    USE_WORLD_CURRENCY: 'useWorldCurrency',
    RUN_PHRASE_EDITOR: 'runPhraseEditor',
    STOP_PHRASE_EDITOR: 'stopPhraseEditor',
    PDF: 'pdf',
    REFERENCE_PROCESSOR: 'referenceProcessor',
    QE_DEBUG: 'qeDebug'
} as const;

export const QUERY_AB_TEST = Object.fromEntries(
    Object.entries(EXISTED_STATSIG_AB_TESTS).map(([name, { statsigKey }]) => [
        name
            .replace(/([A-Z])/g, '_$1')
            .toUpperCase()
            .replace(/^_/, ''),
        statsigKey
    ])
) as Record<string, string>;
